import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index.js'
import store from './store'
import api from '@/request/index.js' //导入api接口
import './assets/css/reset.css'
// import BoeUi from 'boe-ui';
// import 'boe-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/icon/iconfont.css'
import Tool from '@/utils/tool'
import directive from '@/utils/directive'
import md5 from "js-md5"
import './assets/icons/index'; // icon
import VueClipboard from 'vue-clipboard2';
import { PullRefresh } from 'vant';
Vue.use(PullRefresh);

Vue.config.productionTip = false
// Vue.use(BoeUi);
Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.prototype.$api = api
Vue.prototype.$tool = Tool
Vue.prototype.$md5 = md5
// 截图
import VueCropper from 'vue-cropper';
Vue.use(VueCropper)
Vue.directive('copy',directive.copy)

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
